/**
 * Formata o nome do arquivo, para remover dados indesejados
 * @param {*} filename nome do arquivo
 * @returns nome formatado
 */

export const formatFilename = (filename) => {
    const indexNum = filename.split("-")[0];
    return filename.replace(indexNum+"-", "")
}